/* eslint-disable react/jsx-one-expression-per-line */
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import P1 from '@base/P1/P1';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import { Spacings } from '@styles/index';
import H4 from '@base/H4/H4';
import Layout from '@layout/index';
import LeftContainer from '@cont/CompanyDetails/LeftContainer';
import RightContainer from '@cont/CompanyDetails/RightContainer';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const CookiePolicyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
`;

const CookiePolicyContainer = styled.div``;

const H2Container = styled.div``;

const StyledOrderedList = styled.ol`
  padding-left: ${Spacings.SPACING_4B};
`;

const StyledList = styled.li`
  margin-bottom: ${Spacings.SPACING_1B};
`;

const CookiePolicy = () => {
  const router = useRouter();
  const { pathname } = router;

  return (
    <>
      <LeftContainer>
        <MenusNav data={menus} currentHref={pathname} />
      </LeftContainer>

      <RightContainer>
        <CookiePolicyWrapper>
          <CookiePolicyContainer>
            <H2Container>
              <H2 as="h1">Cookies Policy</H2>
            </H2Container>
            <br />
            <br />
            <P1>
              This Cookies Policy supplements our Privacy Policy and describes
              the different types of cookies and other similar technologies that
              may be used in connection with the Platform to facilitate the
              Services to You. This Cookies Policy also describes how you can
              manage cookies and other similar technologies. Please read this
              Cookies Policy with our Privacy Policy.
            </P1>
            <br />
            <P1>
              Capitalized terms used but not defined in this Cookies Policy can
              be found in our Privacy Policy, Terms of Service, and any other
              rules, policies or guidelines published on the Platform as
              applicable to you (collectively referred to as the
              <strong> “Platform Terms”</strong>).
            </P1>
            <br />
            <P1>
              By accessing our Platform, you agree to the use of cookies and
              similar technologies for the purposes described in this Cookies
              Policy.
            </P1>
            <br />

            <StyledOrderedList type="A">
              <li>
                <H4>
                  <b>What are Cookies and other similar technologies?</b>
                </H4>
                <br />
                <P1>
                  Cookies are small files of data in the form of text files
                  created by web browsers you may use and is stored on your
                  device’s hard drive. They allow website providers to identify
                  users, store preferential information, and understand users’
                  browsing activities. There are other similar technologies (
                  <i>as specified below</i>) that allow us and third parties to
                  obtain information about your visits to the Site, usage of the
                  Platform, including to analyze your visiting patterns. We use
                  this information to provide Services on the Platform and
                  messages and content for us and others that are specific to
                  your interests.
                </P1>

                <br />
              </li>
              <li>
                <H4>
                  <b>Cookies and Similar Technologies – General Information</b>
                </H4>
                <br />

                <P1>
                  There are two main types of cookies: First-party cookies which
                  are set by Unacademy directly when you use our Site, and
                  third-party cookies which are set by other websites, such as
                  that of certain third-party services providers whose platform
                  may be integrated with our Platform to facilitate Services to
                  you.
                </P1>
                <br />
                <P1>
                  Cookies alone cannot be used to disclose your individual
                  identity to us, though in some cases we may tie Unacademy or
                  third-party Cookies to personal information you have provided
                  to us or that we have otherwise obtained about you in
                  accordance with our Privacy Policy.
                </P1>
                <br />
                <P1>
                  Other technologies that may be used include web beacons, which
                  are tiny that are used to understand browsing activity; social
                  widgets - these are buttons or icons provided by third- party
                  social media providers that allow you to interact with social
                  media services when you view a webpage or mobile app screen.
                  These social widgets may collect browsing data, which may be
                  received by the third party that provided the widget and are
                  controlled by third parties; UTM codes are strings that can
                  appear in a URL (the “Uniform Resource Locator,” which is
                  typically the http or https address entered to go to a web
                  page) when you move from one web page or website to another,
                  where the string can represent information about browsing,
                  such as which advertisement, page, or publisher sent the user
                  to the receiving website; and site optimization and usage
                  tracking.
                </P1>
                <br />
                <P1>
                  We may contract with third party service providers to help
                  manage and optimize our Internet business and communications,
                  and these third-party service providers may also use the
                  technologies described in this section to collect certain
                  information.
                </P1>
                <br />
              </li>
              <li>
                <H4>
                  <b>
                    What Cookies and Other Technologies Are in Use and Why Do We
                    Use Them?
                  </b>
                </H4>
                <br />

                <P1>We may use different types of cookies on the Platform:</P1>
                <br />
                <ul>
                  <StyledList>
                    <P1>
                      <strong>Essential Cookies:</strong> Essential Cookies are
                      necessary for the Platform to work and enable you to move
                      around it and use its services and features. Disabling
                      these cookies may make the services and features
                      unavailable.
                    </P1>
                  </StyledList>
                  <StyledList>
                    <P1>
                      <strong>Functional Cookies:</strong> We use Functional
                      Cookies to save your settings on the Platform—settings
                      such as language and other user preferences you have
                      previously opted for on the Site. We may also use
                      &quot;Flash Cookies&quot; for some of our animated or
                      other video content.
                    </P1>
                  </StyledList>
                  <StyledList>
                    <P1>
                      <strong>Session Cookies:</strong> These types of cookies
                      are stored only temporarily during a browsing session and
                      are deleted from your device when you close the browser or
                      the application. We use Session Cookies to support the
                      functionality of the Platform and to understand your use
                      of the Platform—that is, which pages you visit, which
                      links you use, what content you are viewing, and how long
                      you stay on each page.
                    </P1>
                  </StyledList>
                  <StyledList>
                    <P1>
                      <strong>Persistent Cookies:</strong> These types of
                      cookies are not deleted when you close your browser or the
                      application but are saved on your device for a fixed
                      period of time or until you delete them. Each time you
                      visit the Platform, the server that set the cookie will
                      recognize the persistent cookie saved on your device. We
                      and others may use persistent cookies to store your
                      preferences, so that they are available for your next
                      visit, to keep a more accurate account of how often you
                      visit the Platform, how often you return, how your use of
                      the Platform may vary over time and the effectiveness of
                      advertising efforts.
                    </P1>
                  </StyledList>
                  <StyledList>
                    <P1>
                      <strong>Analytics Cookies:</strong> Analytics Cookies
                      collect information about your use of the Platform and
                      enable us to improve the way it works. These cookies give
                      us aggregated information that we use to monitor site
                      performance, count page visits, spot technical errors, see
                      how users reach the Platform, and measure the
                      effectiveness of advertising (including emails we send to
                      you).
                    </P1>
                  </StyledList>
                  <br />
                  <P1>
                    Apart from the above, we may also use the following types of
                    cookies-
                  </P1>
                  <br />
                  <StyledList>
                    <P1>
                      <strong>Advertising Cookies:</strong> These cookies allow
                      us and other advertisers to show you the most relevant
                      products, offers, and advertisements on the Platform and
                      third-party sites, or through emails or other message
                      platforms. These types of cookies also help us provide you
                      with content on the Platform that is tailored to your
                      interests and needs. As noted below, some Analytics
                      Cookies and other technologies are used in part to
                      facilitate advertising. Advertising Cookies also include
                      Social Plug-In Cookies.
                    </P1>
                  </StyledList>
                  <StyledList>
                    <P1>
                      <strong>Social Plug-In Cookies:</strong> Social Plug-In
                      Cookies are used to share content from the Platform with
                      members and non-members of social media networks such as
                      Facebook, Twitter, YouTube and Pinterest. These cookies
                      are usually set by the social networking provider,
                      enabling such sharing to be smooth and seamless.
                    </P1>
                  </StyledList>
                  <br />
                  <P1>
                    Cookies may also be used on the Platform in order to improve
                    your experience. For example, we may use cookies to:
                  </P1>
                  <br />
                  <StyledList>
                    <P1>
                      Remember your username and password for future visits so
                      that log-in is easier and faster;
                    </P1>
                  </StyledList>
                  <StyledList>
                    <P1>
                      Track your response to Platform content for analysis;
                    </P1>
                  </StyledList>
                  <StyledList>
                    <P1>
                      Measure how many people use the Platform, and how they use
                      it, so that we may keep it running quickly and
                      efficiently; and
                    </P1>
                  </StyledList>
                  <H4>
                    <P1>
                      Help us and others deliver communications and content to
                      you that are relevant and responsive to your interests and
                      location.
                    </P1>
                  </H4>
                  <br />

                  <P1>
                    <strong>Google Analytics:</strong> We use Google Analytics
                    to collect and process statistical data about the number of
                    people using the Platform and to better understand how they
                    find and use the Platform. The data collected includes data
                    related to your device/browser and on-site activities to
                    measure and report statistics about user interactions on the
                    Platform. Any data collected is used in accordance with this
                    Policy and Google’s privacy policy. You may learn more about
                    Google Analytics by visiting{' '}
                    <a
                      href="https://www.google.com/policies/privacy/partners/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://www.google.com/policies/privacy/partners/
                    </a>{' '}
                    and{' '}
                    <a href="https://support.google.com/analytics/answer/6004245">
                      https://support.google.com/analytics/answer/6004245
                    </a>
                    . You can learn more about Google’s restrictions on data use
                    by visiting the Google Privacy Policy at:{' '}
                    <a href="https://www.google.com/policies/privacy">
                      https://www.google.com/policies/privacy
                    </a>
                    . To opt-out of Google Analytics, visit{' '}
                    <a href="https://tools.google.com/dlpage/gaoptout">
                      https://tools.google.com/dlpage/gaoptout
                    </a>{' '}
                    and install the opt-out browser add-on feature. For more
                    details, visit the “Google Analytics opt-out browser add-on”
                    page (located at{' '}
                    <a href="https://support.google.com/analytics/answer/181881?hl=en">
                      https://support.google.com/analytics/answer/181881?hl=en
                    </a>
                    ).
                  </P1>
                  <br />
                  <P1>
                    <strong>Other Third-Party Technologies:</strong> Some third
                    parties may use automated data collection technologies to
                    collect information about you when you browse the Internet.
                    The information they collect about your online browsing
                    activities over time and across different websites and other
                    online services may be associated with your personal
                    information and used to provide you with targeted content.
                    We do not control these third parties’ technologies or how
                    they may be used. If you have any questions about targeted
                    content, you should contact the responsible party directly
                    or consult their privacy policies.
                  </P1>
                </ul>
                <br />
              </li>
              <li>
                <H4>
                  <b>Choices About Cookies</b>
                </H4>
                <br />

                <P1>
                  We provide you with choices regarding the personal information
                  you provide to us, and we have created ways to give you
                  control over your information. Most web browsers are set by
                  default to accept cookies. If you do not wish to receive
                  cookies, you may choose to set your browser to remove or
                  reject cookies by adjusting your browser settings. Please be
                  aware that, if you decline the use of cookies, you may not
                  have access to the full benefits of the Platform.
                </P1>
                <br />
                <P1>
                  To manage third-party usage of Other Technologies, contact the
                  third party directly or consult their privacy policies.
                  Unacademy is not responsible for third-party use of Other
                  Third-Party Technologies.
                </P1>

                <br />
              </li>
              <li>
                <H4>
                  <b>Contact Us</b>
                </H4>
                <br />

                <P1>
                  If you have any questions regarding this Cookies Policy,
                  please write to us at{' '}
                  <a href="mailto:privacy@unacademy.com">
                    privacy@unacademy.com
                  </a>
                  .
                </P1>
                <br />
              </li>
            </StyledOrderedList>

            <br />
            <P1>
              <i>Cookies Policy – Version 1.0</i>
            </P1>
            <P1>
              <i>Last Updated on 17th March 2022</i>
            </P1>
          </CookiePolicyContainer>
        </CookiePolicyWrapper>
      </RightContainer>
    </>
  );
};

CookiePolicy.pageInfo = {
  name: 'Cookie Policy',
  isMWebSupported: true,
  layoutOptions: {
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

export default CookiePolicy;
CookiePolicy.Layout = Layout;
CookiePolicy.Wrapper = PageReduxProvider;
